module.exports = __webpack_public_path__ + "static/1-248163f716888ea829cecfe5cd9907c0.jpg";